import {atom} from "recoil";

export const csatShowState = atom({
  key: 'csatShowState',
  default: '',
  effects: []
});
